export const getBase = (document) => {
  return document.baseURI || document.getElementsByTagName('base')[0].href;
};
